import chrome from 'images/chrome.svg';
import firefox from 'images/firefox.svg';
import edge from 'images/edge.svg';
import safari from 'images/safari.svg';
import safariIOS from 'images/safari-ios.svg';

import { getCP3Env } from '../CP3Config';

export const GO_BACK_LABEL = 'Need to go back?';
export const CLICK_GO_TO_OLD_LAVU =
	'Click here to switch back to the old lavu.';
export const BROWSER_DOES_NOT_SUPPORT_IFRAME =
	'Your browser does not support iframes.';
export const GOOGLE_CHROME_LABEL = 'Google Chrome';
export const APPLE_SAFARI_LABEL = 'Apple Safari';
export const MOZILLA_FIREFOX = 'Mozilla Firefox';
export const MICROSOFT_EDGE = 'Microsoft Edge';

// new constants file

export const SUPPORTED_BROWSERS = {
	DESKTOP: {
		CHROME: {
			id: 'Chrome',
			label: GOOGLE_CHROME_LABEL,
			download: getCP3Env('REACT_APP_CHROME_URL'),
			icon: chrome,
		},
		SAFARI: {
			id: 'Safari',
			label: APPLE_SAFARI_LABEL,
			download: getCP3Env('REACT_APP_SAFARI_URL'),
			icon: safari,
		},
		FIREFOX: {
			id: 'Firefox',
			label: MOZILLA_FIREFOX,
			download: getCP3Env('REACT_APP_FIREFOX_URL'),
			icon: firefox,
		},
		EDGE: {
			id: 'Edge',
			label: MICROSOFT_EDGE,
			download: getCP3Env('REACT_APP_EDGE_URL'),
			icon: edge,
		},
	},
	MOBILE: {
		CHROME: {
			id: 'Chrome',
			label: GOOGLE_CHROME_LABEL,
			icon: chrome,
		},
		SAFARI: {
			id: 'Mobile Safari',
			label: APPLE_SAFARI_LABEL,
			icon: safariIOS,
		},
		FIREFOX: {
			id: 'Firefox',
			label: MOZILLA_FIREFOX,
			icon: firefox,
		},
		EDGE: {
			id: 'Edge',
			label: MICROSOFT_EDGE,
			icon: edge,
		},
	},
};

// The order matters in this array
export const SECTIONS_OBJ = [
	{ name: 'home', url: 'home/overview' },
	{ name: 'endofday', url: 'endofday/overview' },
	{ name: 'workforce', url: 'workforce/timecards' },
	{ name: 'transactions', url: 'transactions/orders' },
	{ name: 'webgift', url: 'webgift' },
	{ name: 'newreports', url: 'newreports/home' },
	{ name: 'reports', url: 'reports/sales_and_payments' },
	{ name: 'inventory', url: 'inventory' },
	{ name: 'menu', url: 'menus/items' },
	{ name: 'layout', url: 'layout/tables' },
	{ name: 'orderHardware', url: 'orders/hardwares' },
	{ name: 'assistance', url: 'assistance/guide' },
	{ name: 'extensions', url: 'extensions/all' },
	{ name: 'settings', url: 'settings/location' },
	{ name: 'marketplace', url: 'marketplace' },
];
